import React from 'react'
import { useSelector } from 'react-redux';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';

export default function Loading() {
    const { isLoading } = useSelector(state => state.loading);
    return (
        <div>
            {isLoading ? <Box sx={{ display: 'flex' }}><CircularProgress /></Box> : null}
        </div>
    );
}
